var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImage1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 10.78C7.50002 9.93219 7.71956 9.09884 8.13725 8.36107C8.55494 7.6233 9.15655 7.00625 9.8835 6.57C9.91902 6.54874 9.94843 6.51863 9.96885 6.48261C9.98927 6.4466 10 6.4059 10 6.3645V2H14V6.3645C14 6.4485 14.044 6.5265 14.1165 6.5695C14.8435 7.00579 15.4452 7.62292 15.8629 8.36079C16.2806 9.09865 16.5001 9.93211 16.5 10.78V21C16.5 21.2652 16.3946 21.5196 16.2071 21.7071C16.0196 21.8946 15.7652 22 15.5 22H8.5C8.23478 22 7.98043 21.8946 7.79289 21.7071C7.60536 21.5196 7.5 21.2652 7.5 21V10.78Z",
    stroke: "#D6FF41",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 5H14",
    stroke: "#D6FF41",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 11.5H12V19H16.5",
    stroke: "#D6FF41",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 20V10.5",
    stroke: "#D6FF41",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10 6V4",
    stroke: "#D6FF41",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14 6V4",
    stroke: "#D6FF41",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage1);
export default __webpack_public_path__ + "static/media/Image1.de0ef9f6ced3103e204080d570dc46b1.svg";
export { ForwardRef as ReactComponent };